import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 font-mono text-[11px] font-bold uppercase tracking-[0.22em] ${
      dark
        ? "border-white/10 bg-white/5 text-[#C9B8F5]"
        : "border-[#E9DFFC] bg-[#F6F1FF] text-[#7C3AED]"
    }`}
  >
    <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-[#9B5CF0]" : "bg-[#7C3AED]"}`} />
    {children}
  </span>
);

export const SectionHead = ({ eyebrow, title, sub, dark = false, center = true, testId }) => (
  <div className={`${center ? "mx-auto text-center items-center" : "text-left items-start"} flex max-w-2xl flex-col gap-5`}>
    <Reveal>
      <Eyebrow dark={dark} testId={testId ? `${testId}-eyebrow` : undefined}>{eyebrow}</Eyebrow>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        data-testid={testId ? `${testId}-title` : undefined}
        className={`text-3xl font-extrabold leading-[1.12] tracking-tight sm:text-4xl ${dark ? "text-white" : "text-[#171321]"}`}
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`text-base leading-relaxed sm:text-lg ${dark ? "text-[#B8B1C8]" : "text-[#777181]"}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);

export const GradientText = ({ children }) => (
  <span className="bg-gradient-to-r from-[#9B5CF0] to-[#6D28D9] bg-clip-text text-transparent">{children}</span>
);

export const CtaButton = ({ href, children, testId, dark = false, className = "" }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#9B5CF0] via-[#7C3AED] to-[#6D28D9] px-7 py-3.5 text-[15px] font-bold text-white shadow-[0_10px_25px_-5px_rgba(124,58,237,0.45)] transition-[transform,box-shadow] duration-200 hover:scale-[1.03] hover:shadow-[0_18px_40px_-5px_rgba(124,58,237,0.65)] active:scale-[0.98] ${className}`}
  >
    {children}
  </a>
);

export { EASE };
